<div class="preview-pdf-attachment" [ngClass]="{'attachment-render-done':renderDone}">
    <canvas *ngFor="let item of canvasArray" [id]="item.id" [height]="item.height" [width]="item.width"></canvas>
</div>